import {cs} from "./chain-services";
import {Load2} from "./load2";

export const Load = ({fetch, next, disabled=false, keepOutdatedValue=false, captureException=false, _key=undefined}) => cs(
    ["load2", ({}, next) => Load2({
        fetch, next, _key, disabled,
        captureException, keepOutdatedValue,
    })],
    ({load2}) => next(load2.value),
);

